<div class="full-width has-nav wrapper">
  <div class="container m-auto header">
    <div class="description">
      <small> ebook voyage </small>
      <h1>[Ebook] 5 randonnées incontournables à faire en Belgique</h1>
      <p>
        Tu es amateur de randonnée ? Tu as envie de <b>visiter la Belgique autrement</b>&nbsp;?
        <br />
        Cet ebook <b>gratuit</b> est le guide qu’il te faut pour découvrir les sentiers de randonnée
        incontournables en Belgique.
      </p>
      <form>
        @if(submitted && !(nameInput.invalid || emailInput.invalid)){
        <span> Merci ! Rendez-vous dans ta boite mail ! </span>
        } @if(submitted && (nameInput.invalid || emailInput.invalid)){
        <span class="error"> Merci de remplir le formulaire pour recevoir l'ebook </span>
        }
        <input
          type="text"
          [(ngModel)]="name"
          #nameInput="ngModel"
          name="name"
          required
          placeholder="Ton prénom"
          [disabled]="submitted && !(nameInput.invalid || emailInput.invalid)"
          (change)="submitted = false"
        />
        <input
          type="email"
          [(ngModel)]="email"
          #emailInput="ngModel"
          name="email"
          required
          placeholder="Ton adresse email"
          [disabled]="submitted && !(nameInput.invalid || emailInput.invalid)"
          (change)="submitted = false"
        />
        <em class="disclaimer">
          En téléchargeant ce guide, vous rejoignez notre newsletter. Les Explorateurs du Monde ne
          vendra pas votre adresse. Désabonnement en un clic.
        </em>
        <button
          type="submit"
          [disabled]="submitted && !(nameInput.invalid || emailInput.invalid)"
          [class.disabled]="nameInput.invalid || emailInput.invalid"
          (click)="downloadEbook()"
          #submit
        >
          Recevoir mon ebook
        </button>
      </form>
    </div>
    <div class="illustration">
      <div class="cover">
        <img
          loading="lazy"
          alt="see more"
          ngSrc="/icons/eye.svg"
          class="eye"
          width="39"
          height="23"
        />
        <img
          loading="lazy"
          alt="ebook mobile"
          ngSrc="/ebook/ebook-mobile.webp"
          class="mobile"
          width="677"
          height="1300"
        />
        <img
          loading="lazy"
          alt="ebook desktop"
          ngSrc="/ebook/ebook-desktop.webp"
          class="desktop"
          width="846"
          height="1200"
        />
        <div class="pluses">
          <img
            *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]"
            loading="lazy"
            alt="plus"
            ngSrc="/icons/plus.svg"
            class="plus"
            width="40"
            height="40"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="container m-auto">
    <div
      class="w-8 sections"
      appArticle
      [manual]="true"
      [isMobile]="deviceService.isMobile()"
      [class.ml-2]="deviceService.isDesktop()"
      [class.w-12]="deviceService.isMobileOrTablet()"
      #article
    >
      @for (section of ebookSections; track section.id) {
      <section [ngClass]="section.customClass">
        <ng-template templateHost [data]="section"></ng-template>
      </section>
      }
    </div>
  </div>
  <div class="articles-container full-width">
    <div
      class="articles w-8 m-auto"
      [class.w-10]="deviceService.isMobileOrTablet()"
      [class.ml-1]="deviceService.isMobileOrTablet()"
    >
      <h2>Découvrir d'autres articles</h2>
      <div
        class="full-width"
        [class.row]="deviceService.isDesktop()"
        [class.articles-mobile]="deviceService.isMobileOrTablet()"
      >
        @for (dArticle of discoverArticles; track dArticle.id) {
        <app-article-card
          class="w-4"
          [class.w-6]="deviceService.isTablet()"
          [class.w-12]="deviceService.isMobile()"
          [article]="dArticle"
          [showDescription]="false"
        >
        </app-article-card>
        }
      </div>
    </div>
  </div>
</div>
